import {useEffect, useState} from "react";
import {isValidDescription, isValidName} from "@dropDesk/utils/helpers/validators";
import {InternalChatEntity} from "@dropDesk/domain/entities/internal_chat/internal_chat_entity";

export const useValidatorInputInternalChat = (internalChat: InternalChatEntity, loading: boolean) => {

    const [errorMessageDescription, setErrorMessageDescription] = useState('');
    const [errorMessageUsers, setErrorMessageUsers] = useState('');


    useEffect(() => {
        validate();
    }, [internalChat]);

    const validate = (): boolean => {
        setErrorMessageDescription('');

        if (!internalChat) {
            return false;
        }
        if (!isValidDescription(internalChat.description) && !loading) {
            setErrorMessageDescription('A descrição deve possuir mais de 2 letras');
            return false;
        } else if ((!internalChat.users || internalChat.users?.length === 0) && !loading) {
            setErrorMessageUsers('O chat interno deve possuir um ou mais atendentes participando');
            return false;
        } else {
            return true;
        }
    }

    return {
        errorMessageDescription,
        setErrorMessageDescription,
        errorMessageUsers,
        validate
    }
};
